import { serviceAgreement } from "@src/utilities/objects";
import type { AddressFields, ContactFields } from "@utils/BasicTypes";
import { validateSideTab } from "@utils/general";
import {
	sanitize,
	validateAddress,
	validateBilling,
	validateContact,
} from "@utils/validation";
import { debounceStorage } from "../../../../..";
import { ui } from "../../../../../interfaces/interfaces";

const FORM_VALIDATION_DELAY = 150;

export const billingMiddleware = async (
	action: { payload: { name: string; value: any } },
	next: any,
) => {
	switch (action.payload.name) {
		// all actions that are not in the switch statement are passed to the next middleware
		// in the chain, or ultimately to the reducer.
		// Actions below are handled by this middleware.
		// All cases directly below are related to validating the customer form on care plan stage 3.
		// TODO: Clarify  case "CarePlanBillingAddressBusinessName": We do not offer currently Care Plan for businesses
		case "CarePlanBillingAddressProperty":
		case "CarePlanBillingAddressBusinessName":
		case "CarePlanBillingAddressCity":
		case "CarePlanBillingAddressLocality":
		case "CarePlanBillingAddressPostcode":
		case "CarePlanBillingAddressStreet":
		case "CarePlanBillingContactEmail":
		case "CarePlanBillingContactFirstName":
		case "CarePlanBillingContactLandline":
		case "CarePlanBillingContactLastName":
		case "CarePlanBillingContactMobile":
		case "CarePlanBillingContactTitle": {
			const stage = "CarePlan";
			const step = "Billing";
			const property = action.payload.name.replace(stage + step, "");
			const subStep = property.includes("Address") ? "Address" : "Contact";
			const sanitizeProperty = property.replace(subStep, "");

			const Address = serviceAgreement.serviceAgreementBillingAddress;

			action.payload.value = sanitize(
				action.payload.value,
				sanitizeProperty,
				false,
			);

			if (subStep === "Address") {
				const validateInputAndForm = () => {
					validateAddress(
						"CarePlanBillingAddress",
						sanitizeProperty as AddressFields,
						action.payload.value,
					);
					validateSideTab("CarePlanBillingAddress");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			} else {
				{
					const validateInputAndForm = () => {
						validateContact(
							"CarePlanBillingContact",
							sanitizeProperty as ContactFields,
							action.payload.value,
						);
						validateSideTab("CarePlanBillingContact");
					};
					debounceStorage.addOrExecute({
						name: action.payload.name,
						delay: FORM_VALIDATION_DELAY,
						callback: validateInputAndForm,
					});
				}
				break;
			}
			switch (sanitizeProperty) {
				case "Property":
					Address.property = action.payload.value;
					break;

				case "Street":
					Address.street = action.payload.value;
					break;

				case "Locality":
					Address.locality = action.payload.value;
					break;

				case "City":
					Address.town = action.payload.value;
					break;

				case "Postcode":
					Address.postcode = action.payload.value;
					break;

				case "BusinessName":
					Address.organisation = action.payload.value;
					break;

				default:
					break;
			}

			return next(action);
		}

		case "CarePlanBillingAddressAsProperty":
			if (action.payload.value) {
				serviceAgreement.serviceAgreementBillingAddress.property =
					ui.PropertyAddressProperty;
				serviceAgreement.serviceAgreementBillingAddress.street =
					ui.PropertyAddressStreet;
				serviceAgreement.serviceAgreementBillingAddress.locality =
					ui.PropertyAddressLocality;
				serviceAgreement.serviceAgreementBillingAddress.town =
					ui.PropertyAddressCity;
				serviceAgreement.serviceAgreementBillingAddress.postcode =
					ui.PropertyAddressPostcode;
				serviceAgreement.serviceAgreementBillingAddress.organisation =
					ui.PropertyAddressBusinessName;
			} else {
				serviceAgreement.serviceAgreementBillingAddress.property =
					ui.CarePlanBillingAddressProperty;
				serviceAgreement.serviceAgreementBillingAddress.street =
					ui.CarePlanBillingAddressStreet;
				serviceAgreement.serviceAgreementBillingAddress.locality =
					ui.CarePlanBillingAddressLocality;
				serviceAgreement.serviceAgreementBillingAddress.town =
					ui.CarePlanBillingAddressCity;
				serviceAgreement.serviceAgreementBillingAddress.postcode =
					ui.CarePlanBillingAddressPostcode;
				serviceAgreement.serviceAgreementBillingAddress.organisation = "";
				// ServiceAgreement.serviceAgreementBillingAddress.organisation = ui.CarePlanBillingAddressBusinessName;
			}
			{
				const validateInputAndForm = () => {
					validateSideTab("CarePlanBillingAddress");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			}
			return next(action);

		case "CarePlanBillingContactAsContact":
			{
				const validateInputAndForm = () => {
					validateSideTab("CarePlanBillingContact");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			}
			return next(action);

		case "CarePlanBillingMethodPaymentType":
			{
				const validateInputAndForm = () => {
					validateBilling(
						"CarePlanBillingMethod",
						"PaymentType",
						action.payload.value,
					);
					validateSideTab("CarePlanBillingMethod");
				};
				debounceStorage.addOrExecute({
					name: action.payload.name,
					delay: FORM_VALIDATION_DELAY,
					callback: validateInputAndForm,
				});
			}
			return next(action);
	}

	return next(action);
};
